import { useCallback } from 'react'

interface BatchSizeSliderProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
}

export function BatchSizeSlider({
  value,
  onChange,
  min = 1,
  max = 200,
  step = 1,
}: BatchSizeSliderProps) {

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value, 10)
    onChange(newValue)
  }, [onChange])

  const marks = [1, 50, 100, 150, 200]

  return (
    <div className="w-full space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-600">Anzahl Lehrer pro Batch:</span>
        <span className="font-medium text-blue-600">{value}</span>
      </div>
      
      <div className="relative pt-2">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={handleChange}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
          style={{
            background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${((value - min) / (max - min)) * 100}%, #e5e7eb ${((value - min) / (max - min)) * 100}%, #e5e7eb 100%)`
          }}
        />
        
        {/* Mark labels */}
        <div className="flex justify-between mt-2 text-xs text-gray-400">
          {marks.map((mark) => (
            <span
              key={mark}
              className={mark === value ? 'text-blue-600 font-medium' : ''}
            >
              {mark}
            </span>
          ))}
        </div>
      </div>
      
      <p className="text-xs text-gray-500 flex items-start gap-1">
        <span className="text-blue-500">ℹ️</span>
        <span>
          Bei mehr als {value} Lehrern wird die Operation in mehrere Batches aufgeteilt.
          Empfohlen: 50 für optimale Performance.
        </span>
      </p>
    </div>
  )
}
